module.exports = __webpack_public_path__ + "img/icon-pre-complete.4f8678c5.svg";